import React, { FunctionComponent } from 'react';
import { Button } from 'reactstrap';
import styles from './text-button.module.scss';
import history from 'src/lib/history';

interface OwnProps {
  text: string;
  buttonText: string;
  path: string;
  textColor?: string;
  from?: string;
}

type Props = OwnProps;

const TextButton: FunctionComponent<Props> = ({
  text,
  buttonText,
  path,
  textColor,
  from = '',
}: OwnProps) => {
  return (
    <div className={styles.textButton}>
      <p style={{ color: textColor }}>{text}</p>
      <Button
        key="login-btn"
        size="md"
        outline
        onClick={(): void => {
          if (!!from) {
            history.push(path, { from });
          } else {
            history.push(path);
          }
        }}>
        {buttonText}
      </Button>
    </div>
  );
};

export default TextButton;
